__turbopack_context__.v({
  "desktopRightContent": "V2CheckoutAndIdentity-module__OlpZxa__desktopRightContent",
});
